<template>
	<section ref="sectionPeople"
			 class="flex-module container-fluid flexible-people">
		<div v-if="item.title"
			 class="row">
			<div class="col-xs-12">
				<h2 class="section-title">
					{{ item.title }}
				</h2>
			</div>
		</div>
		<div v-for="person in item.people"
			 :key="person"
			 class="row person-entry">
			<div class="col-xs-12 col-sm-8 col-sm-offset-4 col-md-7 col-md-offset-5 col-xl-6 col-xl-offset-6">
				<BasePerson :data="person.people_id" />
			</div>
		</div>
	</section>
</template>

<script setup>
const props = defineProps({
	data: {
		type: Object,
		required: true,
	}
})

const item = computed(() => props?.data?.item)

const { gsap } = useGsap()

const sectionPeople = ref(null)
const triggers = {}

function animRevealPeople() {
	const $q = gsap.utils.selector(sectionPeople.value)
	const items = $q('.person')

	items.forEach((item, i) => {
		const $q2 = gsap.utils.selector(item)

		triggers[`revealPerson${i}`] = gsap.timeline({
			scrollTrigger: {
				id: `revealPerson${i}`,
				trigger: item,
				start: 'top 90%',
			}
		})
			.from($q2('picture'), {
				scale: 0,
				rotate: 50,
				ease: 'expo.out',
				duration: 0.85,
			})
			.from($q2('.text'), {
				autoAlpha: 0,
				y: 50,
				ease: 'expo.out',
				duration: 1,
				stagger: 0.15,
			}, 0)
	})
}

function initAnims() {
	animRevealPeople()
}

onMounted(() => {
	useAnims(initAnims, triggers)
})
</script>

<style lang="scss" scoped>
.person-entry {
	margin-bottom: rem-calc(65);

	@include for-devices-above(md) {
		margin-bottom: rem-calc(80);
	}

	@include for-devices-above(lg) {
		margin-bottom: rem-calc(100);
	}
}

:deep(.person) {
	display: flex;
	flex-flow: column nowrap;
	// align-items: center;

	@include for-devices-above(sm) {
		flex-flow: row nowrap;
	}

	.content {
		flex-basis: 50%;
		flex-grow: 2;

		.person-name {
			@include textH5;
			margin: 0 0 6px 0;
		}

		.job-title,
		a {
			@include textBody;
			font-weight: $semiBold;
			margin-bottom: rem-calc(36);
			color: var(--details-color, $colorRed);
		}
	}
}

:deep(.image) {
	padding-bottom: rem-calc(24);
	padding-right: rem-calc(20);

	@include for-devices-above(sm) {
		padding-bottom: unset;
	}

	@include for-devices-above(xxl) {
		padding-right: rem-calc(84);
	}

	picture {
		display: block;
		overflow: hidden;
		border-radius: 50%;
		width: rem-calc(100);
		height: rem-calc(100);

		@include for-devices-above(lg) {
			width: rem-calc(147);
			height: rem-calc(147);
		}

		@include for-devices-above(xl) {
			width: rem-calc(220);
			height: rem-calc(220)
		}

		img {
			object-fit: cover;
			width: 100%;
			height: 100%;
		}
	}
}
</style>
